import { setActiveOperator, setActiveSearchIdParameter, setActiveSearchPhoneParameter, setActiveSelling, setActiveSortParameter } from "@global-state/pages/admin/myProxies/slice";
import { Input, Select, Sorter } from "@ui";
import style from "./OtherActions.module.scss";
import { useAppSelector, useAppDispatch } from "store/hooks";
import { EOperator } from "@interfaces/operator.enum";
import { useEffect, useState } from "react";
import cn from "classnames";

const listSelling = [
    {
        label: "Всі",
        value: ""
    },
    {
        label: "Продається",
        value: "true"
    },
    {
        label: "Не продається",
        value: "false"
    },
]

const listOperators = [
    {
        label: "Всі",
        value: ""
    },
    {
        label: EOperator.Kyivstar,
        value: EOperator.Kyivstar
    },
    {
        label: EOperator.Vodafone,
        value: EOperator.Vodafone
    },
    {
        label: EOperator.lifecell,
        value: EOperator.lifecell
    }
]

export function OtherActions() {
    const [searchParameter, setSearchParameter] = useState<"id" | "phone">("id");

    const activeSortParameter = useAppSelector(state => state.myProxiesAdminPage.activeSortParameter);
    const { activeSearchIdParameter, activeSearchPhoneParameter, activeSelling, activeOperator } = useAppSelector(state => state.myProxiesAdminPage);

    const dispatch = useAppDispatch();

    function onSearchId(value: string) {
        dispatch(setActiveSearchIdParameter(value.replace(/\D/g, "")));
    }

    function onSearchPhone(value: string) {
        dispatch(setActiveSearchPhoneParameter(value.replace(/\D/g, "")));
    }

    useEffect(() => {
        if (activeSearchIdParameter) {
            setSearchParameter("id")
        }
        if (activeSearchPhoneParameter) {
            setSearchParameter("phone")
        }
    }, [])

    return (
        <div className={style.container}>
            <div className={style.searchRow}>
                <Input
                    value={String(searchParameter === "id" ? activeSearchIdParameter : activeSearchPhoneParameter).replace(/\D/g, "")}
                    onChange={(value) => searchParameter === "id" ? onSearchId(value) : onSearchPhone(value)}
                    type="search"
                    onSearch={(value) => searchParameter === "id" ? onSearchId(value) : onSearchPhone(value)}
                    label={{
                        text: "Пошук"
                    }}
                    customStyle={{
                        width: "!min-w-[260px] max-md:!min-w-0 max-md:!w-full max-md:!max-w-full",
                        height: "!h-[36px]"
                    }}
                />
                <div className="flex gap-[5px]">
                    <div
                        className={cn(style.searchParameter, searchParameter === "id" && style.active)}
                        onClick={() => {
                            setSearchParameter("id")
                            dispatch(setActiveSearchIdParameter(""));
                            dispatch(setActiveSearchPhoneParameter(""));
                        }}
                    >id роутера</div>
                    <div
                        className={cn(style.searchParameter, searchParameter === "phone" && style.active)}
                        onClick={() => {
                            setSearchParameter("phone")
                            dispatch(setActiveSearchIdParameter(""));
                            dispatch(setActiveSearchPhoneParameter(""));
                        }}
                    >телефон</div>
                </div>
            </div>
            <div className={style.filterRow}>
                <div className={style.filterFields}>
                    <div>
                        <p className={style.label}>Продаж</p>
                        <Select
                            currentValue={listSelling.find(item => item.value === activeSelling) || listSelling[0]}
                            listValues={listSelling}
                            onChange={(value) => {
                                dispatch(setActiveSelling(value.value))
                            }}
                        />
                    </div>
                    <div>
                        <p className={style.label}>Оператор</p>
                        <Select
                            currentValue={listOperators.find(item => item.value.toLocaleLowerCase() === activeOperator.toLocaleLowerCase()) || listOperators[0]}
                            listValues={listOperators}
                            onChange={(value) => {
                                dispatch(setActiveOperator(value.value))
                            }}
                        />
                    </div>
                </div>
                <Sorter
                    currentValue={activeSortParameter}
                    onChange={(value) => {
                        if (activeSortParameter !== value.value) {
                            dispatch(setActiveSortParameter(value.value));
                        } else {
                            dispatch(setActiveSortParameter(""));
                        }
                    }}
                    listValue={[
                        {
                            label: "Термін дії",
                            value: "term"
                        }
                    ]}
                />
            </div>
        </div>
    )
}